export default __webpack_public_path__ + "static/media/card-success.4ecd8079.svg";